/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantTimecardAuthorizationRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetMerchantTimecardAuthorizationResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getMerchantTimecardAuthorization = (request: GetMerchantTimecardAuthorizationRequest, options?: CashRequestOptions) => post<GetMerchantTimecardAuthorizationRequest, GetMerchantTimecardAuthorizationResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetMerchantTimecardAuthorization", request, {...options, rejectOnError: true })